<ion-card class="card">
  <div class="card__cover">
    @if (content.image) {
    <img
      class="card__cover-image"
      [src]="content.image"
    />} @else {
      <img
      class="card__cover-image"
      src="../../../../assets/images/registration/back-img-desk.png"
    />
    }
    @if(!content.public) {
      @if(managView) {
        <ion-chip class="card__cover-chip">Privado</ion-chip>
      } @else {
        <ion-chip class="card__cover-chip">{{ 'content.private' | translate }}</ion-chip>
      }
    } @else if(managView) {
    <ion-chip class="card__cover-chip">Público</ion-chip>
    }
  </div>

  <div class="card__content">
    <ion-card-header class="card__header">
      <ion-card-title class="card__header-title">{{
        title
      }}</ion-card-title>
    </ion-card-header>
    <ion-card-content class="card__description">
      <p>{{ description }}</p>
    </ion-card-content>
  </div>

  <div class="card__footer">
    @if(managView) {
    <a (click)="handleRedirect()">
      Gestionar contenido</a
    >
    } @if(managView || content.state !== 2) {

      <a
      target="_blank"
      [href]="getLinkUrl(content)"
      (click)="handleClick(content, $event)"
    >
      {{ !managView ? ('content.offert' | translate) : 'Test' }}
    </a>

    } @else if(!managView){
    <app-general-error code="content.warning" type="warning" />
    }
  </div>
</ion-card>
